module.exports = __webpack_public_path__ + "img/ele.e43c0413.svg";